const google_maps_input = 'AIzaSyC1f4ALyhBGuHEb0Buul_gCIsn1cEj1ewQ'

export default google_maps_input